import { defineMessages } from 'react-intl';

const scope = 'app.widgets.BusinessStatus';

const graphLabels = defineMessages({
    currentTitle: {
        id: `${scope}.graph.common.bars.current.title`,
        defaultMessage: 'Current',
    },
    lySpitTitle: {
        id: `${scope}.graph.common.bars.lySpit.title`,
        defaultMessage: 'LY-SPIT',
    },
    lyFinalTitle: {
        id: `${scope}.graph.common.bars.lyFinal.title`,
        defaultMessage: 'LY-FINAL',
    },
    y2SpitTitle: {
        id: `${scope}.graph.common.bars.y2Spit.title`,
        defaultMessage: '2Y-SPIT',
    },
    y2FinalTitle: {
        id: `${scope}.graph.common.bars.y2Final.title`,
        defaultMessage: '2Y-FINAL',
    },
    guaranteed: {
        id: `${scope}.graph.common.labels.guaranteed`,
        description: 'Label for a guaranteed value (in tooltip)',
        defaultMessage: 'Guaranteed: {value}',
    },
    nonGuaranteed: {
        id: `${scope}.graph.common.labels.nonGuaranteed`,
        description: 'Label for a non guaranteed value (in tooltip)',
        defaultMessage: 'Unguaranteed: {value}',
    },
});

const csvExportLabels = defineMessages({
    exportLink: {
        id: `${scope}.csvExport.link`,
        defaultMessage: 'Export to CSV',
    },
    exportedFileName: {
        id: `${scope}.csvExport.filenamed`,
        defaultMessage: 'business-status',
    },
    // Column headers
    guaranteedRoomsColumn: {
        id: `${scope}.csvExport.column.rooms.guaranteed`,
        defaultMessage: 'Guaranteed rooms',
    },
    nonGuaranteedRoomsColumn: {
        id: `${scope}.csvExport.column.rooms.nonGuaranteed`,
        defaultMessage: 'Unguaranteed rooms',
    },
    totalRoomsColumn: {
        id: `${scope}.csvExport.column.rooms.total`,
        defaultMessage: 'Total rooms',
    },
    guaranteedRevenueColumn: {
        id: `${scope}.csvExport.column.revenue.guaranteed`,
        defaultMessage: 'Guaranteed revenue',
    },
    nonGuaranteedRevenueColumn: {
        id: `${scope}.csvExport.column.revenue.nonGuaranteed`,
        defaultMessage: 'Unguaranteed revenue',
    },
    totalRevenueColumn: {
        id: `${scope}.csvExport.column.revenue.total`,
        defaultMessage: 'Total revenue',
    },
    // Row labels
    currentRowLabel: {
        id: `${scope}.csvExport.row.label.current`,
        defaultMessage: 'Current',
    },
    lySpitRowLabel: {
        id: `${scope}.csvExport.row.label.lySpit`,
        defaultMessage: 'LY-SPIT',
    },
    lySpitVarianceRowLabel: {
        id: `${scope}.csvExport.row.label.lySpitVariance`,
        defaultMessage: 'LY-SPIT Variance',
    },
    lyFinalRowLabel: {
        id: `${scope}.csvExport.row.label.lyFinal`,
        defaultMessage: 'LY-FINAL',
    },
    lyFinalVarianceRowLabel: {
        id: `${scope}.csvExport.row.label.lyFinalVariance`,
        defaultMessage: 'LY-FINAL Variance',
    },
    y2SpitRowLabel: {
        id: `${scope}.csvExport.row.label.y2Spit`,
        defaultMessage: '2Y-SPIT',
    },
    y2SpitVarianceRowLabel: {
        id: `${scope}.csvExport.row.label.y2SpitVariance`,
        defaultMessage: '2Y-SPIT Variance',
    },
    y2FinalRowLabel: {
        id: `${scope}.csvExport.row.label.y2Final`,
        defaultMessage: '2Y-FINAL',
    },
    y2FinalVarianceRowLabel: {
        id: `${scope}.csvExport.row.label.y2FinalVariance`,
        defaultMessage: '2Y-FINAL Variance',
    },
});

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Business status',
    },
    noData: {
        id: `${scope}.noDataMessage`,
        defaultMessage: 'No data available in selected period.',
    },
    roomGraphTitle: {
        id: `${scope}.graph.rooms.title`,
        defaultMessage: 'Rooms',
    },
    revenueGraphTitle: {
        id: `${scope}.graph.revenue.title`,
        defaultMessage: 'Revenue',
    },
});
export { graphLabels, csvExportLabels };
